const resources = {
    en: {
        translation: {
            terms_and_services_name: 'Public Affairs Partners LLC',

            website_domain: 'PublicAffairsPartners.com',
            meta_title_suffix: 'Public Affairs Partners',

            support_email: 'support@PublicAffairsPartners.com',

            support_contact_email: 'support@publicaffairspartners.com',
            support_contact_name: 'Joseph',

            url_tos: 'https://www.publicaffairspartners.com/terms-of-service',
            url_help: 'https://www.publicaffairspartners.com/contact/',
            url_contact: 'https://www.publicaffairspartners.com/contact',

            campaign_asset_best_practises_text: 'Ad FAQs',
            campaign_asset_best_practises_url:
                'https://www.publicaffairspartners.com/post/understanding-creative-requirements'
        }
    }
}

export default resources
